var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import SwiperCore, { Keyboard, Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ChipGroupWrapper, Container, ScrollButton } from './styles';
import { extractNumberFromSizeInPixels } from '../../utilities';
import { Chip } from '../Chip';
import { Icon } from '../Icon';
import 'swiper/swiper.min.css';
SwiperCore.use([Controller, Keyboard]);
var ARROW_SIZE = 27;
export var ChipGroup = function (_a) {
  var chipList = _a.chipList,
    _b = _a.withGradient,
    withGradient = _b === void 0 ? true : _b;
  var _c = useState(),
    swiper = _c[0],
    setSwiper = _c[1];
  var _d = useState(false),
    showPrevArrow = _d[0],
    setShowPrevArrow = _d[1];
  var _e = useState(true),
    showNextArrow = _e[0],
    setShowNextArrow = _e[1];
  var _f = useState(0),
    height = _f[0],
    setHeight = _f[1];
  var groupWrapperReference = useRef(null);
  var theme = useTheme();
  useEffect(function () {
    var _a, _b;
    if (!swiper) return;
    setHeight((_b = (_a = groupWrapperReference.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
    // Disable drag and drop if all chips elements are visible
    swiper.allowTouchMove = showPrevArrow || showNextArrow;
  }, [swiper, showPrevArrow, showNextArrow]);
  if (chipList.length < 1) return null;
  return _jsxs(Container, {
    children: [showPrevArrow && _jsx(ScrollButton, {
      side: "left",
      size: height,
      onClick: function () {
        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
      },
      tabIndex: -1,
      children: _jsx(Icon, {
        type: "icon-chevron-left-big",
        size: ARROW_SIZE
      })
    }), showNextArrow && _jsx(ScrollButton, {
      side: "right",
      size: height,
      onClick: function () {
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
      },
      tabIndex: -1,
      children: _jsx(Icon, {
        type: "icon-chevron-right-big",
        size: ARROW_SIZE
      })
    }), _jsx(ChipGroupWrapper, {
      ref: groupWrapperReference,
      isPrevArrowVisible: showPrevArrow && withGradient,
      isNextArrowVisible: showNextArrow && withGradient,
      children: _jsx(Swiper, {
        onSwiper: setSwiper,
        controller: {
          control: swiper
        },
        spaceBetween: extractNumberFromSizeInPixels(theme.tokens.spacing.xs),
        slidesPerView: "auto",
        keyboard: true,
        onFromEdge: function () {
          setShowNextArrow(true);
          setShowPrevArrow(true);
        },
        onReachBeginning: function () {
          return setShowPrevArrow(false);
        },
        onReachEnd: function () {
          return setShowNextArrow(false);
        },
        children: chipList.map(function (chip, index) {
          return _jsx(SwiperSlide, {
            children: _jsx(Chip, __assign({}, chip))
          }, index);
        })
      })
    })]
  });
};